export const optionsUfs = [
    {
        value: 'AC',
        label: 'AC',
    },
    {
        value: 'AL',
        label: 'AL',
    },
    {
        value: 'AP',
        label: 'AP',
    },
    {
        value: 'AM',
        label: 'AM',
    },
    {
        value: 'BA',
        label: 'BA',
    },
    {
        value: 'CE',
        label: 'CE',
    },
    {
        value: 'DF',
        label: 'DF',
    },
    {
        value: 'ES',
        label: 'ES',
    },
    {
        value: 'GO',
        label: 'GO',
    },
    {
        value: 'MA',
        label: 'MA',
    },
    {
        value: 'MT',
        label: 'MT',
    },
    {
        value: 'MS',
        label: 'MS',
    },
    {
        value: 'MG',
        label: 'MG',
    },
    {
        value: 'PA',
        label: 'PA',
    },
    {
        value: 'PB',
        label: 'PB',
    },
    {
        value: 'PR',
        label: 'PR',
    },
    {
        value: 'PE',
        label: 'PE',
    },
    {
        value: 'PI',
        label: 'PI',
    },
    {
        value: 'RJ',
        label: 'RJ',
    },
    {
        value: 'RN',
        label: 'RN',
    },
    {
        value: 'RS',
        label: 'RS',
    },
    {
        value: 'RO',
        label: 'RO',
    },
    {
        value: 'RR',
        label: 'RR',
    },
    {
        value: 'SC',
        label: 'SC',
    },
    {
        value: 'SP',
        label: 'SP',
    },
    {
        value: 'SE',
        label: 'SE',
    },
    {
        value: 'TO',
        label: 'TO',
    },
];

export const optionsRegime = [
    {
        value: 'CLT',
        label: 'CLT',
    },
    {
        value: 'Pessoa Juridica',
        label: 'PJ',
    },
    {
        value: 'CLT ou PJ',
        label: 'CLT ou PJ',
    },
    {
        value: 'Estágio',
        label: 'Estágio',
    },
];

export const optionsModel = [
    {
        value: 'presential',
        label: 'Presencial',
    },
    {
        value: 'remote',
        label: 'Remoto',
    },
    {
        value: 'presential-remote',
        label: 'Presencial ou Remote',
    },
    {
        value: 'hybrid',
        label: 'Híbrido',
    },
];

